var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 7.99996C14.4001 11.5346 11.5347 14.4 8.0001 14.4C4.46547 14.4 1.6001 11.5346 1.6001 7.99996C1.6001 4.46535 4.46547 1.59998 8.0001 1.59998C11.5347 1.59998 14.4001 4.46535 14.4001 7.99996ZM8.35464 9.78407H7.0626C6.99782 8.61134 7.31828 8.13748 7.95919 7.73861C8.40919 7.46248 8.70237 7.16929 8.70237 6.73975C8.70237 6.26588 8.33078 5.95907 7.87055 5.95907C7.42396 5.95907 7.01146 6.25566 6.99101 6.81134H5.6001C5.63078 5.4477 6.63987 4.79998 7.87737 4.79998C9.23078 4.79998 10.1921 5.49543 10.1921 6.68861C10.1921 7.42838 9.83078 7.94316 9.20351 8.32838C8.57282 8.71702 8.35464 8.97611 8.35464 9.78407ZM8.55237 11.1477C8.54896 11.6011 8.17055 11.9659 7.73419 11.9659C7.28419 11.9659 6.9126 11.6011 6.91601 11.1477C6.9126 10.7011 7.28419 10.3363 7.73419 10.3363C8.17055 10.3363 8.54896 10.7011 8.55237 11.1477Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.9cc587fdfa2e13c5470981acacc28cb1.svg";
export { ForwardRef as ReactComponent };